export enum UserPermission {
  AdminAnnotationManage = 'admin.annotation.manage',
  AdminSpecialcaseManage = 'admin.specialcase.manage',

  AdminExamineeRead = 'admin.examinee.read',
  AdminExaminerCreate = 'admin.examiner.create',
  AdminExaminerPassChange = 'admin.examiner.passchange',
  AdminExaminerRead = 'admin.examiner.read',

  AdminExaminersLineupsManage = 'admin.examiners.lineups.manage',
  AdminExaminersLineupsRead = 'admin.examiners.lineups.read',

  AdminImageUpdate = 'admin.image.update',

  AdminImagezoneManage = 'admin.imagezone.manage',

  AdminOkeExamineeImport = 'admin.oke.examinee.import',
  AdminOkeExamineeRead = 'admin.oke.examinee.read',
  AdminOkeExaminerCreate = 'admin.oke.examiner.create',
  AdminOkeExaminerRead = 'admin.oke.examiner.read',
  AdminOkeResultsExport = 'admin.oke.results.export',
  AdminOkeResultsAccess = 'admin.oke.results.access',

  AdminOkeExaminersLineupsManage = 'admin.oke.examiners.lineups.manage',
  AdminOkeExaminersLineupsRead = 'admin.oke.examiners.lineups.read',

  AdminOkeTaskSolutionSheetRead = 'admin.oke.tasksolutionsheet.read',
  AdminOkeTaskSolutionSheetUpdate = 'admin.oke.tasksolutionsheet.update',
  AdminOkeTaskSolutionSheetProcessing = 'admin.oke.tasksolutionsheet.processing',

  AdminOkeTaskSolutionSheetPageUpdate = 'admin.oke.tasksolutionsheet.page.update',

  AdminResultsAccess = 'admin.results.access',

  AdminFinanceAccess = 'admin.finance.access',
  AdminOkeFinanceAccess = 'admin.oke.finance.access',

  AdminOkeTeamImport = 'admin.oke.team.import',

  AdminOkeUserPasswordChange = 'admin.oke.user.passchange',
  AdminOkeUserRead = 'admin.oke.user.read',

  AdminPanelManage = 'admin.panel.manage',

  AdminRoleManage = 'admin.role.manage',

  AdminRolePermissionsRead = 'admin.roleperm.read',

  AdminSampleExamsheetManage = 'admin.sampleexamsheet.manage',

  AdminSessionCreate = 'admin.session.create',
  AdminSessionDelete = 'admin.session.delete',

  AdminSessionParamsManage = 'admin.sessionparams.manage',

  AdminSessionRead = 'admin.session.read',

  AdminSessionScheduleManage = 'admin.sessionschedule.manage',

  AdminSessionStatusManage = 'admin.sessionstatus.manage',

  AdminSettingsManage = 'admin.settings.manage',

  AdminCalendarRead = 'admin.calendar.read',
  AdminCalendarManage = 'admin.calendar.manage',

  AdminTasksolutionsheetDelete = 'admin.tasksolutionsheet.delete',
  AdminTaskSolutionSheetUpdate = 'admin.tasksolutionsheet.update',
  AdminTasksSolutionSheetRead = 'admin.tasksolutionsheet.read',
  AdminTasksSolutionSheetProcessing = 'admin.tasksolutionsheet.processing',

  AdminUserCreate = 'admin.user.create',
  AdminUserDeactivation = 'admin.user.deactivation',
  AdminUserPassChange = 'admin.user.passchange',
  AdminUserPasswordChange = 'admin.user.passchange',
  AdminUserRead = 'admin.user.read',

  AdminUserRolesManage = 'admin.userroles.manage',

  AdminCommunicationAccess = 'admin.communication.access',
  AdminOkeCommunicationAccess = 'admin.oke.communication.access',

  AdminOkeHelpdeskProcessing = 'admin.oke.helpdesk.processing',

  AdminSupportManage = 'admin.support.manage',
  
  AdminLabelManage = 'admin.label.manage',
  
  AdminStatisticsDashboardRead = 'admin.statistics.dashboard.read',

  ExaminerCreate = 'examiner.create',

  ExaminerDashboardRead = 'examiner.dashboard.read',

  ExaminerRead = 'examiner.read',
  ExaminerUpdate = 'examiner.update',

  ExaminerCommunicationAccess = 'examiner.communication.access',

  TaskSolutionSheetRead = 'tasksolutionsheet.read',
  TaskSolutionSheetReadOwnCommittee = 'tasksolutionsheet.read.owncommittee',

  UserDetails = 'user.details',
  UserRead = 'user.read',

  UserSelfPasswordChange = 'user.self.passChange',
  UserSelfUpdate = 'user.self.update',

  UserUpdate = 'user.update',

  UserCalendarRead = 'user.calendar.read',

  SupportRead = 'user.support.read',

  UserReportRead = 'user.report.read',

}